import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchOrgInvoice(agro_exporter_id, org_invoice_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/manage_org_invoice_payment/${agro_exporter_id}/fetch_org_invoice/${org_invoice_id}`
    );
  },
  fetchOrgInvoicePayment(agro_exporter_id, org_invoice_payment_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/manage_org_invoice_payment/${agro_exporter_id}/fetch_org_invoice_payment/${org_invoice_payment_id}`
    );
  },
  create(agro_exporter_id, org_invoice_id, org_invoice_payment_params) {
    return RequesterV1.post(
      `agro_exporter/finances/container_outcomes/manage_org_invoice_payment/${agro_exporter_id}/create/${org_invoice_id}`,
      { org_invoice_payment: org_invoice_payment_params }
    );
  },
  update(agro_exporter_id, org_invoice_payment_id, org_invoice_payment_params) {
    return RequesterV1.post(
      `agro_exporter/finances/container_outcomes/manage_org_invoice_payment/${agro_exporter_id}/update/${org_invoice_payment_id}`,
      { org_invoice_payment: org_invoice_payment_params }
    );
  },
  destroy(agro_exporter_id, org_invoice_payment_id) {
    return RequesterV1.delete(
      `agro_exporter/finances/container_outcomes/manage_org_invoice_payment/${agro_exporter_id}/destroy/${org_invoice_payment_id}`,
    );
  }
};
